/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Amount_DueInputs */

const en_orders_amount_due = /** @type {(inputs: Orders_Amount_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount Due`)
};

const es_orders_amount_due = /** @type {(inputs: Orders_Amount_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monto pendiente`)
};

/**
* | output |
* | --- |
* | "Amount Due" |
*
* @param {Orders_Amount_DueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_amount_due = /** @type {((inputs?: Orders_Amount_DueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Amount_DueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_amount_due(inputs)
	return es_orders_amount_due(inputs)
});